import { z } from 'zod';

export const socialMediaFormSchema = z.object({
  youtube: z.object({
    enabled: z.boolean(),
    value: z.string().optional(),
  }),

  instagram: z.object({
    enabled: z.boolean(),
    value: z.string().optional(),
  }),

  facebook: z.object({
    enabled: z.boolean(),
    value: z.string().optional(),
  }),

  twitter: z.object({
    enabled: z.boolean(),
    value: z.string().optional(),
  }),

  whatsapp: z.object({
    enabled: z.boolean(),
    value: z.string().optional(),
  }),

  linkedin: z.object({
    enabled: z.boolean(),
    value: z.string().optional(),
  }),

  tiktok: z.object({
    enabled: z.boolean(),
    value: z.string().optional(),
  }),
});

export type SocialMediaFormData = z.infer<typeof socialMediaFormSchema>;
